import { render, staticRenderFns } from "./add-quiz.html?vue&type=template&id=4e3c404b&scoped=true&"
import script from "./add-quiz.js?vue&type=script&lang=js&"
export * from "./add-quiz.js?vue&type=script&lang=js&"
import style0 from "./add-quiz.scss?vue&type=style&index=0&id=4e3c404b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c404b",
  null
  
)

export default component.exports